import { createApp } from 'vue'
import App from './App.vue'
import Swal from 'sweetalert2'  // ✅ 匯入 SweetAlert2
import router from './router' // ✅ 匯入 router
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import "@/assets/css/utils/global.css";


const app = createApp(App)

app.use(router) // ✅ 啟用 Vue Router
app.component('font-awesome-icon', FontAwesomeIcon) // 全域註冊
app.mount('#app')
// ✅ 加入全域屬性 (之後可用 this.$swal)
app.config.globalProperties.$swal = Swal
